import { Location } from 'react-router-dom';

export const emptyLocation: Location = {
    hash: '',
    key: '',
    pathname: '',
    search: '',
    state: null,
};
